"use client"

import { motion } from "framer-motion"
import { ReactNode } from "react"

type ScaleOnHoverProps = {
  children: ReactNode
  scale?: number
  className?: string
}

export const ScaleOnHover = ({
  children,
  scale = 1.02,
  className = ""
}: ScaleOnHoverProps) => {
  return (
    <motion.div
      whileHover={{ scale }}
      whileTap={{ scale: scale * 0.98 }}
      transition={{
        type: "spring",
        stiffness: 400,
        damping: 17
      }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
